import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestUserShifts, emptyRequestUserShifts, getRequestUserPersonnelShifts} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';
import { values } from 'lodash';

@connect((state) => ({
  userShifts: state.FormBuilder.Common.SelectUserShift.userShifts,
}), {
  getRequestUserShifts,
  getRequestUserPersonnelShifts,
  emptyRequestUserShifts,
})
@autobind
/**
 *
 */
export default class SelectUserShift extends React.PureComponent {
  static propTypes = {
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    required: PropTypes.bool,
    meta: PropTypes.object,
    validateStatus: PropTypes.oneOf([
      'success', 'warning', 'error', 'validating',
    ]),
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.string,
      PropTypes.node,
    ]),
    size: PropTypes.oneOf([
      'small', 'default', 'large',
    ]),
    disabled: PropTypes.bool,
    mode: PropTypes.oneOf([
      'multiple', 'tags', 'combobox',
    ]),
    multiple: PropTypes.bool,
    inline: PropTypes.bool,
    tags: PropTypes.bool,
    optionFilterProp: PropTypes.string,
    optionLabelProp: PropTypes.string,
    showSearch: PropTypes.bool,
    defaultActiveFirstOption: PropTypes.bool,
    dropdownStyle: PropTypes.object,
    dropdownClassName: PropTypes.string,
    getPopupContainer: PropTypes.func,
    labelInValue: PropTypes.bool,
    tokenSeparators: PropTypes.array,
    combobox: PropTypes.bool,
    allowClear: PropTypes.bool,
    key: PropTypes.string,
    title: PropTypes.string,
    onChange: PropTypes.func,
    dropdownMatchSelectWidth: PropTypes.bool,
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    notFoundContent: PropTypes.string,
    filterOption: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.func,
    ]),
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func,
    onSearch: PropTypes.func,
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.string),
      ]),
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
    }),
    positionId: PropTypes.string,
    getMethod: PropTypes.string,
    dateKey: PropTypes.string,
    rest: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    style: PropTypes.object,
    values: PropTypes.object,
    getRequestUserShifts: PropTypes.func,
    getRequestUserPersonnelShifts: PropTypes.func,
    emptyRequestUserShifts: PropTypes.func,
    initialize: PropTypes.func,
  };

  static defaultProps = {
    inline: false,
    label: undefined,
    validateStatus: undefined,
    required: false,
    input: {
      value: undefined,
    },
    values: {},
    disabled: false,
    multiple: false,
    tags: false,
    combobox: false,
    allowClear: false,
    filterOption: false,
    dropdownMatchSelectWidth: true,
    optionFilterProp: 'value',
    optionLabelProp: 'children',
    size: 'default',
    showSearch: false,
    defaultActiveFirstOption: true,
    getPopupContainer: () => document.body,
    labelInValue: false,
    notFoundContent: app.translate('main.Not Found'),
    style: {
      width: '100%',
    },
    getMethod: 'positionKey',
    dateKey: 'date',
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      userShifts: [],
    };
  }

  /**
   *
   */
  componentWillMount() {
    super.componentWillMount();

    const {input, defaultValue} = this.props;

    input.onChange(defaultValue);
  }

  /**
   *
   */
  componentDidMount() {

    this._get(this.props);
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    let date = app._.camelCase(np.dateKey);
      console.log("dfgdrg", this.props.values);

    if (
      (np.values && this.props.values && np.values.values && this.props.values.values &&
        np.values.values[date] && this.props.values.values[date] &&
        !app._.isEqual(np.values.values[date], this.props.values.values[date])) ||
      (np.values && this.props.values && np.values.values && (!this.props.values.values || !this.props.values.values[date]) && np.values.values[date] )) {
      // console.log(date, np.values.values);
      // np.initialize(Object.assign({}, np.values, {userShift: '0'}));
      np.input.onChange(null);
      this._get(np);
    } else {
      if(!np.values.values[date] || np.values.values[date]===""){
        this.setState({userShifts: []});
        np.input.onChange("");
      }
      if (np.getMethod !== 'positionKey') {
        if(!np.values.values.substituteId || np.values.values.substituteId===""){
          this.setState({userShifts: []});
          np.input.onChange("");
        }
      }
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestUserShifts();
  }

  _get = (props = undefined) => {
    const {getMethod, dateKey} = props;
    let date = app._.camelCase(dateKey);
         
    if (props && props.values && props.values.values && props.values.values[date]) {
      if (getMethod === 'positionKey') {
        props.getRequestUserShifts({
          positionId: props.values.positionId,
          date: props.values.values[date],
        }, (r) => {
          if(r) {
            this.setState({userShifts: r.data.workingHours});
          }
        });
      } else {
        if(props.values.values.substituteId && props.values.values.substituteId!=="") {
          props.getRequestUserPersonnelShifts({
            personnelId: props.values.values.substituteId,
            date: props.values.values[date],
          }, (r) => {
            if (r) {
              this.setState({userShifts: r.data.workingHours});
            }
          });
        }
      }
    }
  };


  /**
   *
   * @return {String}
   * @private
   */
  _getMode() {
    const {multiple, mode} = this.props;
    let _mode;

    if (mode) {
      _mode = mode;
    } else if (multiple) {
      _mode = 'multiple';
    }

    return _mode;
  }

  /**
   *
   * @return {String}
   * @private
   */
  _validateStatus() {
    const {disabled, required, validateStatus, input, meta} = this.props;
    let _status = validateStatus;

    if (!disabled) {
      if (meta.asyncValidating) {
        _status = 'validating';
      } else if (meta.touched) {
        if (meta.error) {
          _status = 'error';
        } else {
          if (!required && app._.isEmpty(input.value)) {
            _status = 'warning';
          } else if (meta.valid) {
            _status = 'success';
          }
        }
      }
    }

    return _status;
  }

  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  _value(value) {
    let {userShifts} = this.state;
    let shiftId = value && value.shiftId;
    let workingHour = value && value.workingHour;

    if (workingHour && userShifts && userShifts[0]) {

      let index = userShifts.findIndex((item) =>{ return (shiftId !== null ?  parseInt(item.id) === parseInt(!Array.isArray(shiftId) ? shiftId : shiftId[0]) : item.id === null)});
      if (index > -1 && userShifts[index] &&
        userShifts[index].workingDays && userShifts[index].workingDays[0] &&
        userShifts[index].workingDays[0].workingHour) {
        let _index = userShifts[index].workingDays.findIndex((_item) => parseInt(_item.workingHour && _item.workingHour.id) === parseInt(!Array.isArray(workingHour) ? workingHour : workingHour[0]));

        if (_index > -1) {
          return workingHour;
        }
      }
    }
    return undefined;
  }

  /**
   *
   * @return {XML}
   */
  render() {

    const {
      input, disabled, size, tags, optionFilterProp,
      optionLabelProp, showSearch, defaultActiveFirstOption, dropdownStyle,
      dropdownClassName, getPopupContainer, labelInValue, tokenSeparators,
      combobox, allowClear, key, title, dropdownMatchSelectWidth, placeholder,
      notFoundContent, filterOption, children, defaultValue, style, label,
      required, validateStatus, mode, meta, ...rest
    } = this.props;

    let shiftId = null;
    let selectUserShiftes = [];
    if(this.state.userShifts && this.state.userShifts[0]) {
      app._.map(this.state.userShifts, (userShift, index) => {
        //  if (requestUserPosition.user && requestUserPosition.user.profile && positionId.indexOf(requestUserPosition.id) === -1) {
        shiftId = userShift.id;

        app._.map(userShift.workingDays, (_item, _index) => {
          let item = _item && _item.workingHour;

          selectUserShiftes.push(
            <SelectInput.Option
              key={`${uuidv1()}-${index}-${_index}`}
              value={`${_item && _item.workingHourId}`}
              style={{
                borderBottom: '1px solid #f6f6f6',
              }}
            >
              <MaterialIcon
                name='format-color-fill'
                style={{ color: item && item.color ? `${item.color}` : '#1e98cc' }}/>
              {`${userShift && userShift.name} - ${item && item.name}`}
            </SelectInput.Option>,
          );
          //  }
        });
      });
    }
    let _value = this._value(input && input.value);
    let _defaultValue = this._value(defaultValue);


    return (<Form.Item
      label={label}
      help={meta.touched && meta.error}
      required={required}
      validateStatus={this._validateStatus()}
      hasFeedback
      {...this._inline()}
    >
      <SelectInput
        id={input.name}
        name={input.name}
        mode={this._getMode()}
        defaultValue={_defaultValue ?
          mode && (mode === 'multiple' || mode === 'tags') && !Array.isArray(_defaultValue) ? [_defaultValue] : _defaultValue :
          mode && (mode === 'multiple' || mode === 'tags') && !Array.isArray(_value) ? [_value] : _value
        }
        value={mode && (mode === 'multiple' || mode === 'tags') && !Array.isArray(_value) ? [_value] : _value}
        placeholder={placeholder}
        onChange={(v) => {
          input.onChange({workingHour: v, shiftId: shiftId})
        }}
        optionFilterProp={optionFilterProp}
        optionLabelProp={optionLabelProp}
        defaultActiveFirstOption={defaultActiveFirstOption}
        dropdownStyle={dropdownStyle}
        dropdownClassName={dropdownClassName}
        getPopupContainer={getPopupContainer}
        combobox={combobox}
        filterOption={filterOption}
        notFoundContent={notFoundContent}
        title={title}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        key={key}
        allowClear={allowClear}
        tokenSeparators={tokenSeparators}
        labelInValue={labelInValue}
        showSearch={showSearch}
        tags={tags}
        disabled={disabled}
        size={size}
        onBlur={(v) => input.onBlur({workingHour: v, shiftId: shiftId})}
        onFocus={(v) => input.onFocus({workingHour: v, shiftId: shiftId})}
        style={style}
        {...rest}
      >
        {children}
        {selectUserShiftes}
      </SelectInput>
    </Form.Item>);
  }
}
